var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.199463,
    y: 0.00341797,
    width: 48.0046,
    height: 48.0046,
    rx: 24.0023,
    fill: "#45B549"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.875 14.5H20.125C18.7188 14.5 17.625 15.6328 17.625 17V32C17.625 33.4062 18.7188 34.5 20.125 34.5H28.875C30.2422 34.5 31.375 33.4062 31.375 32V17C31.375 15.6328 30.2422 14.5 28.875 14.5ZM24.5 33.25C23.7969 33.25 23.25 32.7031 23.25 32C23.25 31.3359 23.7969 30.75 24.5 30.75C25.1641 30.75 25.75 31.3359 25.75 32C25.75 32.7031 25.1641 33.25 24.5 33.25ZM28.875 17V29.5H20.125V17H28.875Z",
    fill: "#FCFCFC"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIcon);
export default __webpack_public_path__ + "static/media/MobileIcon.e11cceac68c703d5ccdef8599fa3feba.svg";
export { ForwardRef as ReactComponent };